module.exports = __webpack_public_path__ + "static/Team6-d31747de426dfc399004ed8e47bfdefa.png";